import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { connect } from 'react-redux';
import { AssetResourceType } from '../../interfaces';
import { getSession as getSessionAction } from '../../state/actions';
import { IncludedAssetSummary } from './IncludedAssetSummary';

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var includedAssets = ownProps.includedAssets;
  var sessions = state.session.sessions;
  var retrievedAssets = [];
  includedAssets.forEach(function (a) {
    if (a.resourceType === AssetResourceType.SESSION && sessions[a.resourceId]) {
      retrievedAssets.push(_objectSpread(_objectSpread({}, a), {}, {
        context: sessions[a.resourceId]
      }));
    }
  });
  return {
    retrievedAssets: retrievedAssets
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fetchAsset: function fetchAsset(assetResource) {
      switch (assetResource.resourceType) {
        case AssetResourceType.SESSION:
          {
            return dispatch(getSessionAction(assetResource.resourceId));
          }
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IncludedAssetSummary);